import React, { useEffect, useRef, createContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

// Component
import MakeRoomDataRoom from '../../components/MakeRoom/MakeRoomDataRoom';
import MakeRoomDataGuest from '../../components/MakeRoom/MakeRoomGuest';

// API & Action & Unit
import * as bookingApi from '../../api/booking';
import * as branchApi from '../../api/branch';
import * as invoiceApi from '../../api/invoice';
import * as guestApi from '../../api/guest';

import { modalAction, makeRoomAction, unitsAction } from '../../redux/actions';
import { informationToast, errorToast, } from '../../utils/Toast/index'; // warningToast
import ModalSupportOption from '../Unit/Modal/modalSupportOption';
import ModalNotify from '../../features/ModalNotify';
import MakeRoomFooterButton from '../../components/MakeRoom/MakeRoomOther/MakeRoomFooterButton';
import { changeStringVNDtoNumber } from '../../utils/Currency/SupportCurrency'
import ViewPassPortGuest from '../../components/MakeRoom/ViewPassPortGuest/ViewPassPortGuest';
import ListEditLog from '../../components/MakeRoom/Other/ListEditLog';

import './makeRoom.css';
  
const style = {
    container: {
        textAlign: "left",
        margin: 5,
        backgroundColor: '#d8dbdd'
    },
    icon: {
        color: 'blue',
        fontSize: '1.4rem',
        textAlign: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        marginTop: 5,
        marginLeft: 5,
    },
    children: {
        border: '0.5px solid rgba(0,255,255,0.8)',
        padding: '4px'
    },
    label: {
        fontSize: '1.3rem',
        width: '120px',
        margin: 0,
        padding: 0,
        fontWeight: '500'
    },
    labelMakeRoom: {
        fontSize: '1.3rem',
        width: '90px',
        margin: 0,
        padding: 0,
        fontWeight: '500'
    },
    textarea: {
        width: '465px',
        fontSize: '1.4rem',
    },
    text: {
        fontSize: '1.4rem'
    },
    time: {
        fontSize: '1.4rem',
        padding: '4px',
        width: '20px'
    }
};

export const UserContext = createContext();

function MakeRoomContainer() {
    const dispatch = useDispatch();
    const token = useSelector(state => state.token);
    const makeRoomOnState = useSelector(state => state.makeRoom);
    const makeRoomService = useSelector(state => state.makeRoomOther);
    const listChangeGuest = useRef({});
    const [statusWaiting, setStatusWaiting] = useState("");
    const { branchID, roomSelect, checkin, idRoom, typeRoom, id_history } = useParams();

    const [listHistory, setListHistory] = useState([]);
    const [selectHistoryIndex, setSelectHistoryIndex] = useState('');

    const auth = useSelector(state => state.auth);
    const isHaNoiBranch = Number(branchID) === 3 || Number(branchID) === 8 || Number(branchID) === 12 || Number(branchID) === 15 || Number(branchID) === 16 ||  Number(branchID) === 99;
    const [viewFullPassPort] = useState(false);
    const [click, setClick] = useState(true);
    const { user } = auth;
    let history = useHistory();
    const checkRoomAvailableRef = useRef(checkRoomAvailable);
    checkRoomAvailableRef.current = checkRoomAvailable;
   
    useEffect(() => {
        let active = true;
        if (!branchID) {
            alert('Error when make room');
        } else {
            if (token !== "") {
                if(id_history === undefined) {
                    if (typeRoom === undefined) {
                        if (idRoom === undefined) {
                            document.title = `New:${roomSelect}-(${checkin})`;
                            dispatch(makeRoomAction.takaDataBookingBySelect({ branchID, roomSelect, checkin }));
                        } else if (idRoom === "make_waiting") {
                            dispatch(makeRoomAction.takaDataBookingByWaitingList({ branchID }));
                        } else {
                            dispatch(makeRoomAction.takeDataBookingByID({ branchID, id: idRoom }));
                        }
                    } else {
                        dispatch(makeRoomAction.takaDataBookingByWaitingList({ branchID }));
                        checkRoomAvailableRef.current(token, "new_reservation");
                    }
                } else {
                    // 
                    const loadServer = async () => {
                        setListHistory([]);
                        setSelectHistoryIndex('');
                        try {
                            const response = await bookingApi.getListHistoryOnLog(branchID, id_history, token);
                            if (!active) return;
                            const entries = response.data.data;
                            if (!Array.isArray(entries)) throw new Error('Invalid history response');
                            setListHistory(entries);
                            if (entries.length > 0) setSelectHistoryIndex(entries[entries.length - 1]._id);
                            else errorToast("No history found for this booking");
                            document.title = "History";
                        } catch (error) {
                            if (!active) return;
                            console.error(error);
                            return errorToast("Error when load history")
                        }
                    }

                    loadServer();
                }
            } 
        }
        
        return () => { active = false; };
    }, [token, branchID, id_history, idRoom, roomSelect, checkin, typeRoom, dispatch]);

    useEffect(() => {
        if(token && id_history && selectHistoryIndex) {
            dispatch(makeRoomAction.takeHistoryByID({ branchID, id: selectHistoryIndex }));
        }
    },[selectHistoryIndex, token, branchID, id_history, dispatch]);

    useEffect(() => {
        // support Waiting Area
        //makeRoomService.area === "waiting"
        if ( makeRoomService.area === "waiting" && Number(branchID) === 99) {
            // check room available
            const checkRoomWaiting = async () => {
                const result = await bookingApi.checkRoomWaitingList(branchID, idRoom, token);

                if(result) {
                    if(result.data.status === 1) {
                        if(result.data.isAvailable) {
                            setStatusWaiting("Room waiting available, do you want remove to schedule list ? !!")
                        //  dispatch(makeRoomAction.changeChiddenMakeRoomOther({ value: "available", target: "status_waiting", option: "" }))
                        } else {
                            console.log("Room waiting not available")
                        //   dispatch(makeRoomAction.changeChiddenMakeRoomOther({ value: "not_available", target: "status_waiting", option: "" }))
                        }
                    } else {
                        return errorToast("Error when check room waiting available")
                    }

                } else return errorToast("Error when check room waiting available")
            }
            checkRoomWaiting();
        }
    },[makeRoomService.area, branchID, idRoom, token])

    // console.log("listChangeGuest", listChangeGuest)
    function handleChangeListChangeGuest(value) {
        listChangeGuest.current[value._id] = {};
        listChangeGuest.current[value._id] = value;
    }

    function handleDeleteListChangeGuest(value) {
        if(value._id in listChangeGuest.current) delete listChangeGuest.current[value._id];
        // props.onChangeValueMakeRoom(index, "indexGuestSelect")
    }

    function onChangeValueMakeRoom(value, target, option) {
        //makeRoomService.confirm
        console.log("onChangeValueMakeRoom", value, target, option)
        if (value === "company" && target === "payment") {
            dispatch(makeRoomAction.changeChiddenMakeRoom({ value, target, option }))
            dispatch(makeRoomAction.changeChiddenMakeRoomOther({ value: true, target: "vat", option: "" }))
        } else if(target === "viewPassPort") {
            dispatch(makeRoomAction.changeChiddenMakeRoom({ value: !makeRoomOnState.viewPassPort, target, option }))
        } else if(target === "request1") {
            if(option === "tap") {
                dispatch(makeRoomAction.changeChiddenMakeRoom({  value, target, option: undefined }))
            } else {
                if(!makeRoomOnState.request1.includes(value) && option === "extend"){
                    if(option === "extend") {
                        if(makeRoomOnState.request1 === "") dispatch(makeRoomAction.changeChiddenMakeRoom({  value , target, option }))
                        else dispatch(makeRoomAction.changeChiddenMakeRoom({  value : makeRoomOnState.request1 + ", " +value, target, option }))
                    } 
                } else if (makeRoomOnState.request1.includes(value) && option === "clear") {
                    const newRequest1 = makeRoomOnState.request1.replace(value, "");
                    const newRequest1_2 = newRequest1.replace(",,", ",");
                    const newRequest1_3 = newRequest1_2.replace(" ,", ",");
                    const newRequest1_4 = newRequest1_3.replace(", ", ",");
                    dispatch(makeRoomAction.changeChiddenMakeRoom({  value : newRequest1_4, target, option: undefined }))
                    
                } else {
                    if(makeRoomOnState.request1 === "") {
                       dispatch(makeRoomAction.changeChiddenMakeRoom({  value , target, option }));
                        if((option === 5 || option === 6) && Number(branchID) === 8) dispatch(makeRoomAction.changeChiddenMakeRoomOther({  value : "#0000ff", target: "color", option: undefined }));
                        if((option === 4) && Number(branchID) === 15) dispatch(makeRoomAction.changeChiddenMakeRoomOther({  value : "#7f6000", target: "color", option: undefined }));
                    }
                    else {
                        if(option === 0 )  dispatch(makeRoomAction.changeChiddenMakeRoom({  value : "", target, option: undefined }));
                        if((option === 5 || option === 6) && Number(branchID) === 8)  dispatch(makeRoomAction.changeChiddenMakeRoomOther({  value : "#0000ff", target: "color", option: undefined }));
                        if((option === 4) && Number(branchID) === 15) dispatch(makeRoomAction.changeChiddenMakeRoomOther({  value : "#7f6000", target: "color", option: undefined }));
    
                        const REQUEST_CASE = [
                            "",
                            "Company have contract 5% OFF",
                            "Company have contract free laundry 120.000vnd/day",
                            "Company have contract 5% OFF + free laundry 120.000vnd/day",
                            "Walk In guest",
                            "Shortime guest",
                            "Line Coupon Discount",
                        ]
    
                        const REQUEST_CASE2 = [
                            "",
                            "Company have contract 5% OFF",
                            "Company have contract free laundry 5.5$/day",
                            "Company have contract 5% OFF + free laundry 5.5$/day",
                            "Walk In guest",
                            "Shortime guest",
                            "Line Coupon Discount",
                        ]
    
                        let request1Value
                        let checkValueCase = makeRoomOnState.request1;
    
                        if(makeRoomOnState.request1 === "") {
                            dispatch(makeRoomAction.changeChiddenMakeRoom({  value : request1Value, target, option: option, branchID }))
                        } else {
                            const check1 = branchID !== 11 ? makeRoomOnState.request1.includes(REQUEST_CASE[1]) : makeRoomOnState.request1.includes(REQUEST_CASE2[1]);
                            const check2 = branchID !== 11 ? makeRoomOnState.request1.includes(REQUEST_CASE[2]) : makeRoomOnState.request1.includes(REQUEST_CASE2[2]);
                            const check3 = branchID !== 11 ? makeRoomOnState.request1.includes(REQUEST_CASE[3]) : makeRoomOnState.request1.includes(REQUEST_CASE2[3]);
                            const check4 = branchID !== 11 ? makeRoomOnState.request1.includes(REQUEST_CASE[4]) : makeRoomOnState.request1.includes(REQUEST_CASE2[4]);
                            const check5 = branchID !== 11 ? makeRoomOnState.request1.includes(REQUEST_CASE[5]) : makeRoomOnState.request1.includes(REQUEST_CASE2[5]);
                            const check6 = branchID !== 11 ? makeRoomOnState.request1.includes(REQUEST_CASE[6]) : makeRoomOnState.request1.includes(REQUEST_CASE2[6]);
        
                            if(check3) checkValueCase = checkValueCase.replace(REQUEST_CASE[3], "$CHANGE"); 
                            else if (check2) checkValueCase = checkValueCase.replace(REQUEST_CASE[2], "$CHANGE");
                            else if (check1) checkValueCase = checkValueCase.replace(REQUEST_CASE[1], "$CHANGE");
                            else if (check5) checkValueCase = checkValueCase.replace(REQUEST_CASE[5], "$CHANGE");
                            else if (check4) checkValueCase = checkValueCase.replace(REQUEST_CASE[4], "$CHANGE");
                            else if (check6) checkValueCase = checkValueCase.replace(REQUEST_CASE[6], "$CHANGE");
                            else return dispatch(makeRoomAction.changeChiddenMakeRoom({  
                                value :  value + ", " + makeRoomOnState.request1,  
                                target, 
                                option,
                                branchID })); 
        
                            request1Value = checkValueCase.replace("$CHANGE", value);
                            dispatch(makeRoomAction.changeChiddenMakeRoom({  value : request1Value, target, option, branchID }))

                        }
                    }
                    
                }
            }
        } else if(target === "isNonBreakfast") {
            const checkRequest1 = makeRoomOnState.request1;
            if(checkRequest1 === "")  dispatch(makeRoomAction.changeChiddenMakeRoom({  value : "NON BREAKFAST", target: "request1", option, branchID }))
            else if(!checkRequest1.includes("NON BREAKFAST")) dispatch(makeRoomAction.changeChiddenMakeRoom({  value : "NON BREAKFAST, " + checkRequest1, target: "request1", option, branchID }))
            else if(checkRequest1.includes("NON BREAKFAST")) {
                const newRequest1 = checkRequest1.replace("NON BREAKFAST", "");
                const newRequest1_2 = newRequest1.replace(",,", ",");
                const newRequest1_3 = newRequest1_2.replace(" ,", ",");
                const newRequest1_4 = newRequest1_3.replace(", ", ",");
                dispatch(makeRoomAction.changeChiddenMakeRoom({  value : newRequest1_4, target: "request1", option, branchID }))
            }
            dispatch(makeRoomAction.changeChiddenMakeRoom({ value, target, option }))
        }
        else if (target === "listGuestSelect") {
            // check membership
            // console.log("value[0].userId", value[0].userId)
            // console.log("value[0].contract", value[0].contract)

            // if(value.length > 0) {

            //     if(!LIST_GUEST_ID_BLOCK.includes(value[0]._id)) {
            //         if(!value[0].userId) {
            //             if( !value[0].contract) {
            //                 if(!makeRoomOnState.request2.includes("2 water")) {
            //                    if(makeRoomOnState.request2 === "") dispatch(makeRoomAction.changeChiddenMakeRoom({ value: "2 water", target: "request2", option: "" }))
            //                    else {
            //                         dispatch(makeRoomAction.changeChiddenMakeRoom({ value: "2 water, " + makeRoomOnState.request2, target: "request2", option: "" }))   
            //                    }
            //                 }
            //             }
            //         } else {
            //             if(makeRoomOnState.request2.includes("2 water")) {
            //                 console.log("vo here change 2 water")
            //                 const changeContent = makeRoomOnState.request2.replace("2 water","");
            //                 changeContent.replace("2 water,","");
            //                 dispatch(makeRoomAction.changeChiddenMakeRoom({ value: changeContent, target: "request2", option: "" }))
            //             }
            //         }
            //     }

            // }

            dispatch(makeRoomAction.changeChiddenMakeRoom({ value, target, option }))
        }
        else {
            if(target === "ota") {
                dispatch(makeRoomAction.changeChiddenMakeRoomOther({ value: "confirm", target: "status", option: "" }))
                dispatch(makeRoomAction.changeChiddenMakeRoomOther({ value: true, target: "confirm", option: "" }))
            }
            dispatch(makeRoomAction.changeChiddenMakeRoom({ value, target, option }))
        }
    }

    function checkRoomAvailable(token, type) {
        // call api check room with type

        const onMoveRoomToSchedule = async (roomSelect) => {
           // alert("vo here"+ roomSelect)
            const result = await bookingApi.changeRoomAfterCheckWithType(branchID, idRoom, roomSelect, token);
            if(result){
                if (result.data.status === 1) {
                    informationToast("" + result.data.msg); 
                    window.location.reload();}
                else return errorToast("Error when change room")
            } else return errorToast("Error when change room")
        }

        const onMakeRoomKeepWithList = async (listRoomSelect, roomMain,  checkin, checkout, nights) => {
            //alert("ROom list :" + listRoomSelect)
          //  window.location = `/room/${branchID}/${roomMain}/${checkin}`;
         
            closeModal();
            // make new list Schedule
            // const { checkin, checkout, nights } = dataBooking;
            const newListSchedule =[];
            if (listRoomSelect.length > 0) {
                function checkRoomWithDiscount(price, discount) {
                    // console.log("price", price)
                    // console.log("discount", discount)
                    if (discount === "0" || discount === undefined) return price;
                    else return Math.round(price * (1 - Number(discount) / 100) * 100) / 100;
                }

                // call api take room price list 

                listRoomSelect.forEach(item => {
                    newListSchedule.push({
                            roomSelect: item,
                            move: false,
                            price: checkRoomWithDiscount(changeStringVNDtoNumber(makeRoomOnState.listRoomPrice[item]) ,makeRoomOnState.listSchedule[0].discount),
                            checkin: type === "checkRoomStatus" ? 
                                    new Date(checkin.slice(0, 10) + "@"+makeRoomOnState.listSchedule[0].timeEarly)
                                    : new Date(checkin.slice(0, 10)),
                            checkout: type === "checkRoomStatus" ? 
                                    new Date(checkout.slice(0, 10) + "@" + makeRoomOnState.listSchedule[0].timeLateOut)
                                     : new Date(checkout.slice(0, 10)),
                            nights: nights,
                            discount: makeRoomOnState.listSchedule[0].discount,
                            shortime: false,
                            isTravel: false,
                            earlyCheckin: false,
                            lateOut: false,
                            timeEarly: type === "checkRoomStatus" ? makeRoomOnState.listSchedule[0].timeEarly : checkin.slice(12, 20),
                            timeLateOut: type === "checkRoomStatus" ? makeRoomOnState.listSchedule[0].timeLateOut : checkout.slice(12, 20),
                            timeShortTime: "",
                        })
                })
            }
            window.title = "Make Room"

            if (type ==="new_reservation") {
                history.push(`/room/${branchID}/${roomMain}/${checkin.slice(0, 10)}`);
            }

           dispatch(makeRoomAction.changeChiddenMakeRoom({ value: newListSchedule, target: "newListSchedule", option: undefined }));
          
            // roomSelect: "605"
            // move: false
            // discount: 0
            // price: makeRoomOnState.listRoomPrice(listRoomSelect[0])
            // checkin: "2024-04-02"
            // checkout: ""
            // nights: ""
            // shortime: false
            // earlyCheckin: false
            // lateOut: false
            // timeEarly: "15:00"
            // timeLateOut: "12:00"
            // timeShortTime: ""
        }

        const onLoadData = async (token) => {
            let result;

            if(type!=="checkRoomStatus") {
                result = await bookingApi.checkRoomWithType(branchID, idRoom, typeRoom, token);
            } else {
                result = await bookingApi.checkRoomWithCalender(branchID, "checkRoomStatus", "new", {
                    checkin: makeRoomOnState.listSchedule[0].checkin,
                    checkout: makeRoomOnState.listSchedule[0].checkout,
                },token);
            }

            // console.log("result", result);
            if(result || type === "checkRoomStatus") {
                if(result.data.status === 1 || result.data.status === 4) {
                    dispatch(modalAction.modalChange({
                        type: "centered",
                        title: "Room with type have available",
                        size: result.data.status === 1 ?  'xs' : 'xl',
                        // featureButton1:{ () },
                        content: < ModalSupportOption
                            type={16} 
                            featureButton1={result.data.status === 1 ? onMoveRoomToSchedule : onMakeRoomKeepWithList}
                            featureButton2={() => window.open(`/room/${branchID}/${idRoom}`, '_self')}
                            itemOption={{
                                type : result.data.status === 1 ? "roomAvailability" : "roomSuggest",
                                typeRoomRequest: typeRoom,
                                schedule: result.data.dataReturn,
                            }}
                        />
                    }));
                    openModal();
                }
                else if (result.data.status === 2) { window.open(`/room/${branchID}/${idRoom}`, '_self') }
                else if(result.data.status === 3) {
                    dispatch(modalAction.modalChange({
                        type: "centered",
                        title: "Room information",
                        size: 'xs',
                        content: < ModalSupportOption
                            type={88}
                            itemOption={{
                                color: "red",
                                title: <>
                                    <h3>{result.data.msg}</h3>
                                    <div className="mt-2">Click goto this room (delete):  
                                        <button className="btn btn-primary"
                                            onClick={()=>window.open(`/room/${branchID}/${idRoom}`,'_self')}>Go to Room</button>
                                    </div>
                                </>
                            }}

                        />
                    }));
                    openModal();
                };

            } else return errorToast("Error when load room data")
            // console.log("reult", result);
        }

        onLoadData(token);
    }

    function onSortListSchedule() {

        const onChangeSortListSchedule = async (data) => {
             dispatch(makeRoomAction.changeChiddenMakeRoom({ value: data, target: "sortListSchedule"  }));
             closeModal();
        }

        dispatch(modalAction.modalChange({
            type: "centered",
            title: "Sort List Schedule",
            size: 'xs',
            content: < ModalSupportOption
                type={13}
                // eslint-disable-next-line no-use-before-define
                featureSupport1={onChangeSortListSchedule}
                featureSupport2={closeModal}
                itemOption={{ 
                    schedule: makeRoomOnState.listSchedule, 
                    code: "sort"
                }}
            />
        }));
        openModal();

    }
    
    function onAddMoreSameListSchedule() {

        function onSelectRoom(data, type) {
            if(data.length > 0) {
                const newData = { ...makeRoomOnState };
                data.forEach(roomSelect => {
                    if(type === "notSame") {
                        newData.listSchedule.push({
                            ...makeRoomOnState.listSchedule[0],
                            booking_id: undefined,
                            price: roomSelect.price,
                            roomSelect: roomSelect.roomSelect
                        });
                    } else {
                        newData.listSchedule.push({
                            ...makeRoomOnState.listSchedule[0],
                            booking_id: undefined,
                            roomSelect,
                        });
                    }
                    newData.scheduleSelect += 1;
                })
                onChangeAllDataValueMakeRoom(newData);
            }
            closeModal();
        }
        
        const onChangeAddMoreSameListSchedule = async (dataCheck) => {
            const result = await bookingApi.automaticCheckRoom(branchID, {
                checkin: makeRoomOnState.listSchedule[0].checkin,
                checkout: makeRoomOnState.listSchedule[0].checkout,
                roomSelect: makeRoomOnState.listSchedule[0].roomSelect,
                price: makeRoomOnState.listSchedule[0].price,
                numberRoomRequest : dataCheck.request.room
            } ,token)
           // dispatch(makeRoomAction.changeChiddenMakeRoom({ value: data, target: "sortListSchedule"  }));
          //   closeModal();

          dispatch(modalAction.modalChange({
            type: "centered",
            title: "Sort List Schedule 2",
            size: 'xs',
            content: <ModalSupportOption
                type={14}
                // eslint-disable-next-line no-use-before-define
                featureSupport1={onChangeAddMoreSameListSchedule}
                featureSupport2={closeModal}
                featureButton1={onSelectRoom}
                itemOption={{ 
                    schedule: result.data.dataReturn, 
                    checkin: makeRoomOnState.listSchedule[0].checkin,
                    checkout: makeRoomOnState.listSchedule[0].checkout,
                    listRoomNumber: makeRoomOnState.listRoomNumber,
                    listRoomPrice: makeRoomOnState.listRoomPrice,
                    code: "same"
                }}
            />
          }));
       }

       dispatch(modalAction.modalChange({
           type: "centered",
           title: "Sort List Schedule",
           size: 'xs',
           content: <ModalSupportOption
               type={14}
               // eslint-disable-next-line no-use-before-define
               featureSupport1={onChangeAddMoreSameListSchedule}
               featureSupport2={closeModal}
               featureButton1={onSelectRoom}

               itemOption={{ 
                   schedule: [], 
                   checkin: makeRoomOnState.listSchedule[0].checkin,
                   checkout: makeRoomOnState.listSchedule[0].checkout,
                   listRoomNumber: makeRoomOnState.listRoomNumber,
                   listRoomPrice: makeRoomOnState.listRoomPrice,
                   code: "same"
               }}
           />
       }));
       openModal();
    }

    function onChangeGuestDataAfterEdit(dataChange, index) {
       // console.log("dataChange", dataChange)
        dispatch(makeRoomAction.updateDataGuestAfterEditMakeRoom({data: dataChange,index}))
    }

    function onChangeAllDataValueMakeRoom(value) {
        dispatch(makeRoomAction.changeAllDataChiddenMakeRoom(value));
    }

    function onConfirmDeleteSchedule(index) {
        const codeDelete = branchID + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);

        if (index === undefined) {
            dispatch(modalAction.modalChange({
                type: "centered",
                title: "Confirm Delete ALL Schedule.",
                size: 'xs',
                content: < ModalSupportOption
                    type={9}
                    featureSupport1={onDelete}
                    featureSupport2={closeModal}
                    itemOption={{ schedule: makeRoomOnState.listSchedule, code: codeDelete }}
                />
            }));
            openModal();
        } else {
            if (makeRoomOnState.listSchedule[index].checkin === "" || makeRoomOnState.listSchedule[index].checkout === "") {
                onDelete();
            } else {
                dispatch(modalAction.modalChange({
                    type: "centered",
                    title: "Confirm Delete Schedule.",
                    size: 'xs',
                    content: < ModalSupportOption
                        type={9}
                        featureSupport1={onDelete}
                        featureSupport2={closeModal}
                        itemOption={{ schedule: makeRoomOnState.listSchedule[index], code: codeDelete }}
                    />
                }));

                openModal();
            }
        }

        function onDelete() {
            const deleteScheduleOnServer = async () => {
                dispatch(unitsAction.showLoading())
                // check guest on waiting list

                try {

                    const newData = { ...makeRoomService, ...makeRoomOnState, };
                    delete newData["listRequest1"];
                    delete newData["listRoomNumber"];
                    delete newData["createNew"];
                    delete newData["timeEdit"];
                    delete newData["deviceEdit"];
                    //    delete newData["listRoomPrice"];
                    delete newData["loading"];
                    delete newData["signature"];
                    delete newData["listRoomPrice"];

                    const resultDelete = await bookingApi.deleteScheduleById(branchID, makeRoomOnState.listSchedule[0].booking_id, newData, token);
                    //return console.log("resultDelete", resultDelete)
                    if (resultDelete) {
                        if (resultDelete.data.status === 1) {
                            informationToast("" + resultDelete.data.msg);
                            if (resultDelete.data.data === "cancel") {
                                window.location.reload();
                                const checkin = new Date(makeRoomOnState.listSchedule[0].checkin);
                                const checkout = new Date(makeRoomOnState.listSchedule[0].checkout);
                
                                const formatDate = (date) => date.toISOString().split("T")[0];
                
                                const dateRangeString = `${formatDate(checkin)}_${formatDate(checkout)}`;
                
                                function onCloseModal() {
                                    return window.open(`/room/${user.branchID}/${idRoom}`, '_self');
                                }
                
                                const checkDataWaitingList = await bookingApi.takeListBookingAreaByType(branchID, "waiting_report", dateRangeString, token);
                
                                if(checkDataWaitingList.data.status === 1) {
                                    if(checkDataWaitingList.data.data.length > 0) {
                                        dispatch(modalAction.modalChange({
                                            type: "centered",
                                            title: "Guest on waiting list",
                                            size: 'xl',
                                            backdrop : "static",
                                            closeButton: false,
                                            content: < ModalSupportOption
                                                type={10}
                                                featureSupport2 = {onCloseModal}
                                                itemOption = {{
                                                    type: "roomOnWaitingList",
                                                    typeInvoice: "roomOnWaitingList",
                                                    data: checkDataWaitingList.data.data,
                                                }}
                                            />
                                        }));
                                    }
                                } else {
                                    return window.open(`/room/${user.branchID}/${idRoom}`, '_self');
                                }
                            }
                            else return window.open(`/reservation`, '_self');

                        } else errorToast("" + resultDelete.data.msg);
                    } else return errorToast("Error when release booking");
                } catch (error) {
                    errorToast("Error when release booking");
                }
                dispatch(unitsAction.hiddenLoading())
            };

            if (index === undefined) {
                deleteScheduleOnServer()
            } else onChangeValueMakeRoom("delete", "listSchedule", index);

          //  closeModal();
        }

        setClick(true);

    }



    function onViewAutoBooking() {

        function onSaveFormatMailAutoBooking(data) {
            const saveMailFormat = async (data) => {
                try {
                    dispatch(unitsAction.showLoading());
                    const result2 = await bookingApi.saveMailFormatAutoBooking(branchID, makeRoomOnState.listSchedule[0].booking_id, data, token);
                    dispatch(unitsAction.hiddenLoading());
                    if (!result2) return errorToast("Error when load data");
                    else {
                        informationToast(result2.data.msg);
                    }
                   // closeModal();
                } catch (error) {
                    errorToast("Error when load data ")
                }
            }
            
            saveMailFormat(data);
        }

        function sendMailAutoBooking(data) {
            const sendMailAutoBookingApi = async (data) => {
                try {
                    dispatch(unitsAction.showLoading());
                    const result2 = await bookingApi.sendMailFormatAutoBooking(branchID, data, token);
                    dispatch(unitsAction.hiddenLoading());
                    if (!result2) return errorToast("Error when load data");
                    else {
                        informationToast(result2.data.msg);
                    }
                     // closeModal();
                } catch (error) {
                    errorToast("Error when load data ")
                }
            }

            sendMailAutoBookingApi(data);
        }

        dispatch(modalAction.modalChange({
            type: "centered",
            title: "Auto Booking Log",
            size: 'xl',
            content: < ModalSupportOption
                type={20}
                featureButton1 = {onSaveFormatMailAutoBooking}
                featureButton2 = {sendMailAutoBooking}
                featureButton3 = {closeModal}
                itemOption = {{
                    booking_id: makeRoomOnState.listSchedule[0].booking_id,
                    branchID: branchID,
                }}
            />
        }));
        openModal()

    }

    function onViewMailFormat() {
        dispatch(modalAction.modalChange({
            type: "centered",
            title: "Mail Format",
            size: 'xl',
            content: < ModalSupportOption
                type={17}
                itemOption = {{
                    type : makeRoomOnState.listGuestSelect[0].name.includes("KEEP")? "suggestRoom" : "makeRoom",
                    branchID: branchID
                }}
            />
        }));

        openModal()
    }

    function onOpenSettingShowRule2Water()  {
        dispatch(modalAction.modalChange({
            type: "centered",
            title: "Member Ship / Minibar rule",
            size: 'lg',
            content: < ModalSupportOption
                type={18}
            />
        }));

        openModal();
    }

    function onOpenSettingRequest1() {
        const onSaveData = async (data) => {
            try {
                const result2 = await branchApi.changeBookingRequest1(branchID, data, token);
                if (!result2) return errorToast("Error when load data");
                else {
                    informationToast(result2.data.msg);
                    // change on client
                    dispatch(makeRoomAction.changeChiddenMakeRoom({ value: data, target: "listRequest1" }));
                }
                closeModal();
            } catch (error) {
                errorToast("Error when load data ")
            }
        }

        const takeBookingRequest1 = async () => {
            try {
                dispatch(unitsAction.showLoading());
                const result = await branchApi.findElementBranch(branchID, "bookingRequest1", token);
                dispatch(unitsAction.hiddenLoading());
                if (!result) return errorToast("Error when load data");
                else {
                    dispatch(modalAction.modalChange({
                        type: "centered",
                        title: "Edit Quick Support Request 1",
                        size: 'xs',
                        content: < ModalSupportOption
                            type={8}
                            featureSupport1={onSaveData}
                            featureSupport2={closeModal}
                            itemOption={result.data.data}
                        />
                    }));
                }
            } catch (error) {
                errorToast("Error when load data")
            }
        }

        takeBookingRequest1();
        openModal();
    }

    function onChangeValueMakeRoomOther(value, target, option) {
        dispatch(makeRoomAction.changeChiddenMakeRoomOther({ value, target, option }));
        // check pickup / dropoff have all infoamtion
        // => fill text on 
        
        // if(target ==="pickup" || target ==="dropoff") {
            
        // }
    }

    function updateListGuest(value) {
        console.log("value",value)
        dispatch(makeRoomAction.changeChiddenMakeRoom({ value, target: "listGuestSelect" }));
        
    }

    function onConfirmCheckRoomStatus() {
        checkRoomAvailable(token,"checkRoomStatus");
    }

    function onConfirmMakeRoom() {
        dispatch(unitsAction.showLoading());
        setClick(false);

        if (makeRoomService.confirm) {
            makeRoomService.status = "confirm";
        }
        const newData = { ...makeRoomService, ...makeRoomOnState, };
        delete newData["listRequest1"];
        delete newData["listRoomNumber"];
        delete newData["createNew"];
        delete newData["timeEdit"];
        delete newData["deviceEdit"];

        //    delete newData["listRoomPrice"];
        delete newData["loading"];
        delete newData["signature"];

        const callApiMakeBookingOnSchedule = async () => {
            try {
                let result;
                //  dispatch(unitsAction.showLoading());
                if(Number(branchID) === 99) {
                    result = await bookingApi.checkRealtime(branchID, newData, token);
                } else result = await bookingApi.makeNewBooking(branchID, newData, token);

                //     dispatch(unitsAction.hiddenLoading());
                if (result) {
                    if (result.data.status === 1) {
                        //  result.data.data
                        informationToast(result.data.msg);
                        dispatch(unitsAction.delay());
                        window.open(`/room/${user.branchID}/${result.data.data}`, '_self');
                    };
                    if (result.data.status === 2) return errorToast(result.data.msg);
                    if (result.data.status === 3) {
                        dispatch(modalAction.modalChange({
                            type: "centered",
                            title: "Double Schedule Booking, Please check again",
                            size: 'xs',
                            content: <ModalSupportOption
                                type={12} //  12 = ModalShowBillDouble
                                button1="View Room Details"
                                button2="Close"
                                typeButton1="btn-primary"
                                typeButton2="btn-danger"
                                featureButton1={() => window.open(`/room/${user.branchID}/${result.data.data.booking_id}`, '_blank')}
                                featureButton2={closeModal}
                                itemOption={result.data.data}
                            />
                        }));
                        openModal();
                    }
                } else {
                    errorToast("Error when update Room, please check again.")
                }
            } catch (error) {
                errorToast("Error when update Room, please check again.")
            }
        }

        const callApiCheckMultiGuest = async () => {
            const dataGuest = await guestApi.checkMultiGuestChange(listChangeGuest.current, token);
            //console.log("dataGuest", dataGuest)
            if(dataGuest.data.status === 1) {
                callApiMakeBookingOnSchedule();
            } else {
                errorToast(dataGuest.data.msg);
                setClick(true);
            }
        }

        const listIDOnListChange = Object.keys(listChangeGuest.current);
       // console.log("listIDOnListChange",listIDOnListChange)
        if( listIDOnListChange.length > 0 ) {
          //alert("Check data guest change")
          callApiCheckMultiGuest();
          setClick(true);
        } else callApiMakeBookingOnSchedule();
        dispatch(unitsAction.hiddenLoading());
        setClick(true);
    }

    function onConfirmEdit() {
        setClick(false);
        if (makeRoomService.confirm) {
            makeRoomService.status = "confirm";
        }
        const newData = { 
            ...makeRoomOnState, 
            ...makeRoomService 
        };

        delete newData["listRequest1"];
        delete newData["listRoomNumber"];
        delete newData["signature"];
        delete newData["listBranchArea"];
        delete newData["indexGuestSelect"];
        
        const callApiEditBooking = async () => {
            try {
                const result = await bookingApi.updateBookingById(branchID, idRoom, newData, token);
                
                if (result) {
                    switch (result.data.status) {
                        case 1: {
                            informationToast(result.data.msg)
                            dispatch(unitsAction.delay());
                            return window.open(`/room/${user.branchID}/${makeRoomOnState.listSchedule[0].booking_id}`, '_self');
                           // return window.open(`/room/${user.branchID}/${idRoom}`, '_self');

                        }
                        case 2: return errorToast(result.data.msg);
                        case 3: return errorToast(result.data.msg + " Booking ID:" + result.data.data.id);
                        case 4: return informationToast("Have change data guests")//warningToast(result.data.msg);
                        default: break;
                    }
                } else {
                    errorToast("Error when update Room, please check again.");
                }
            } catch (error) {
                errorToast("Error when update Room, please check again.")
            }

        }

        const callApiCheckMultiGuest = async () => {
            let dataGuest ;
            const listIDOnListChange = Object.keys(listChangeGuest.current);
            dispatch(unitsAction.showLoading());

            if( listIDOnListChange.length > 0 ) { 
                // console.log("vo here 123")
                //console.log("listChangeGuest.current", listChangeGuest.current)
                dataGuest = await guestApi.checkMultiGuestChange(listChangeGuest.current, token);
            } else {
                // change to object
                // console.log("vo here 234")
                let dataPost = {};
                if (makeRoomOnState.listGuestSelect.length > 0) {
                    makeRoomOnState.listGuestSelect.forEach(dataGuest => {
                        delete dataGuest.rank;
                        delete dataGuest.userId;
                        delete dataGuest.createdAt;

                        dataPost[""+ dataGuest._id] = dataGuest;
                    });
                   // console.log("dataPost", dataPost)
                    dataGuest = await guestApi.checkMultiGuestChange(dataPost, token);
                } else {
                    dataGuest.data = {};
                    dataGuest.data.status = 1;
                }
            }
            dispatch(unitsAction.hiddenLoading());
          // console.log("dataGuest", dataGuest)
            if(dataGuest.data.status === 1) {
                callApiEditBooking();
            } else errorToast(dataGuest.data.msg);
        }
        callApiCheckMultiGuest();

        setClick(true);
    }

    function onViewHistory() {
        window.open("/room_history/"+branchID+"/"+idRoom, "_blank")
        // const loadHistory = async () => {
        //     try {
        //         // const dataResult = await bookingApi.takeBookingHistory(branchID, idRoom, token);
        //         // console.log("dataResult",dataResult);
        //         // dispatch(modalAction.modalChange({
        //         //     type: "centered",
        //         //     title: "View History Booking data",
        //         //     size: 'xl',
        //         //     content: < ModalSupportOption
        //         //         type={5}
        //         //         // featureSupport1={onSaveData}
        //         //         featureSupport2={closeModal}
        //         //         itemOption={{ data: dataResult.data.data, type: "bookingEditStory" }}
        //         //     />
        //         // }));

        //         window.open("someLink", "_blank")

        //     } catch (error) {
        //         errorToast("Error when view booking history");
        //     }
        // }

        // loadHistory();
        // openModal();
    }

    function onPrintBooking() {
        window.open(`/make_booking_bill/${user.branchID}/group/${idRoom}`, '_blank');
    }

    function onConfirmRedo() {

        if (makeRoomService.confirm) {
            makeRoomService.status = "confirm";
        }
        const newData = { ...makeRoomService, ...makeRoomOnState, };
        delete newData["listRequest1"];
        delete newData["listRoomNumber"];
        delete newData["createNew"];
        //    delete newData["listRoomPrice"];
        delete newData["loading"];

        const loadSchedule = async () => {
            try {
                dispatch(unitsAction.showLoading());

                //const sendMail = await bookingApi.sendMailAfterConfirmWaitingList(token);
                // 
                const dataResult2 = await bookingApi.takeBookingDataById(branchID, idRoom, token);
                newData.listSchedule.forEach((item, index) => {
                    newData.listSchedule[index].name = dataResult2.data.data.listGuestSelect[0].name;
                });

            //    console.log("newdata", newData);

                dispatch(modalAction.modalChange({
                    type: "centered",
                    title: "Confirm Redo Booking",
                    size: 'lg',
                    content: < ModalSupportOption
                        type={10}
                        featureSupport1={loadRedoRequest}
                        featureSupport2={closeModal}
                        featureButton2={""}
                        featureButton3={""}
                        featureButton4={""}
                        itemOption={{
                            data: newData.listSchedule,
                            isAddService: false,
                            group_id: dataResult2.data.group_id,
                            invoice_id : "",
                            type: "redoInvoice",
                            search: false,
                        }}
                    />
                }));
                dispatch(unitsAction.hiddenLoading());
                
            } catch (error) {
                errorToast("Error when Check Out");
            }
        }

        // check room select && room price
        loadSchedule();
        openModal();

        const loadRedoRequest = async () => {
            try {
                const dataResult = await bookingApi.redoGuest(branchID, idRoom, makeRoomService.area, newData, token);                
                if(dataResult) {
                    if(dataResult.data.status === 1) {
                        informationToast(dataResult.data.msg);
                        dispatch(unitsAction.delay());
                        dispatch(unitsAction.delay());
                        window.open("/room/"+branchID+"/"+idRoom,'_self');
                    }
                    else if(dataResult.data.status === 3) {
                        
                        dispatch(modalAction.modalChange({
                            type: "centered",
                            title: "Double Schedule Booking, Please check again",
                            size: 'xs',
                            content: < ModalSupportOption
                                type={12} //  12 = ModalShowBillDouble
                                button1="View Room Details"
                                button2="Close"
                                typeButton1="btn-primary"
                                typeButton2="btn-danger"
                                featureButton1={() => window.open(`/room/${user.branchID}/${dataResult.data.data.booking_id}`, '_blank')}
                                featureButton2={closeModal}
                                itemOption={dataResult.data.data}
                            />
                        }));
                        openModal();
                        
                    } else if (dataResult.data.state === 2) {
                        dispatch(modalAction.modalChange({
                            type: "centered",
                            title: "Double Schedule Booking, Please check again",
                            size: 'xs',
                            content: < ModalSupportOption
                                type={88} //  12 = ModalShowBillDouble
                                itemOption={{
                                    title: dataResult.data.msg,
                                    color:"red"
                                }}
                            />
                        }));
                        openModal();
                    }
                }else errorToast("Error when redo guest");
            } catch (error) {
                errorToast("Error when redo guest");
            }
        }
    }

    function onConfirmMakeHotelInvoice(typeInvoice) {
        let keepGroupID = makeRoomOnState.group_id;

        const onChangeGroupID = async (value) => {
            if (value.length === 10) {
                const dataResult4 = await bookingApi.updateGroupId(branchID, idRoom, { value }, token);
                if (dataResult4) {
                    if (dataResult4.data.status === 1) {
                        informationToast("" + dataResult4.data.msg);
                        onChangeValueMakeRoom(value, "group_id");
                        keepGroupID = value;
                        loadSchedule(value);
                    }
                    else errorToast("" + dataResult4.data.msg);
                } else errorToast("" + dataResult4.data.msg);
            } else {
                errorToast("Please check again : group ID length = 10")
            }
        }

        function onOpenAddService() {
            window.open(`/add_service/${user.branchID}/${idRoom}`, '_blank');
        }

        function onOpenMakeHotelInvoice() {
            if(typeInvoice === "Booking") {
                window.open(`/make_booking_bill/${user.branchID}/group/${idRoom}`, '_blank');
            } else if(typeInvoice === "Cancel") {
                window.open(`/make_invoice/${user.branchID}/${idRoom}`, '_blank');
            } else if(typeInvoice === "PMRQ") {
                window.open(`/make_pmrq/${user.branchID}/group/${idRoom}`, '_blank');
            } else window.open(`/make_invoice/${user.branchID}/group/${idRoom}`, '_blank');
        }

        function onReload(id) {
            dispatch(modalAction.modalChange({
                type: "centered",
                title: "Confirm Check Out",
                size: 'lg',
                content: < ModalSupportOption
                    type={99}
                />
            }));

            loadSchedule(id);
        }

        const loadSchedule = async (id) => {
            try {
                dispatch(unitsAction.showLoading());
                const dataResult2 = await bookingApi.takeBookingScheduleListById(branchID, id, typeInvoice ? typeInvoice : "HI", token);
                // Check number invoice => block when have number invoice
                const checkInvoice = await invoiceApi.checkCountHotelInvoiceNumberWithBookingID(branchID, idRoom, token);
                // if booking only on schedule => print the booking
                if(typeInvoice === "Booking") {
                    if(dataResult2.data.data.length ===1 ) {
                        dispatch(unitsAction.hiddenLoading());
                        closeModal();
                        return window.open(`/make_booking_bill/${user.branchID}/${idRoom}`, '_blank');
                    }
                }

                if(typeInvoice ==="PMRQ" && checkInvoice.data.msg ==="Make new") {
                    dispatch(modalAction.modalChange({
                        type: "centered",
                        title: "Make Payment Request",
                        size: 'xs',
                        content: < ModalSupportOption
                            type={88}
                            featureSupport1={""}
                            featureSupport2={closeModal}
                            itemOption={{
                                title: <>
                                    <div>Have not Hotel Invoice, Please request Reception make it.</div>
                                    <div>Không có số Hotel Invoice, xin hãy báo lễ tân thêm.</div>
                                </>,
                                color: "red"
                            }}
                    />
                    }))
                } else {
                    dispatch(modalAction.modalChange({
                        type: "centered",
                        title: typeInvoice ==="PMRQ" ? "Make Payment Request" :
                                    typeInvoice ==="Booking" ?  "Confirm make Booking confirm" :"Confirm Check Out",
                        //size: 'lg',
                        size: 'xl',
                        content: <ModalSupportOption
                            type={10}
                            featureSupport1={() => onReload(keepGroupID)}
                            featureSupport2={closeModal}
                            featureButton2={onOpenAddService}
                            featureButton3={onChangeGroupID}
                            featureButton4={onOpenMakeHotelInvoice}
                            itemOption={{
                                data: dataResult2.data.data,
                                isAddService: checkInvoice.data.status === 1,
                                group_id: dataResult2.data.group_id,
                                invoice_id : checkInvoice.data.status === 1 ? "empty invoice..." : checkInvoice.data.data.invoice_id,
                                type: "makeHotelInvoice",
                                search: false,
                                typeInvoice
                            }}
                        />
                    }));
                }

                dispatch(unitsAction.hiddenLoading());
            } catch (error) {
                errorToast("Error when Check Out");
            }
        }

        if(typeInvoice === "Cancel") {
            window.open(`/make_invoice/${user.branchID}/${idRoom}`, '_blank');
        } else {
            loadSchedule(makeRoomOnState.group_id);
            openModal();
        }
    }

    function onReturnDefaultSignature() {
        const callAPICheckOldData = async () => {
            const result = await branchApi.findElementBranch(branchID,"signature", token);
            onChangeValueMakeRoomOther(result.data.signature,"signature",{index:"", target:"return"})
        }
        callAPICheckOldData()
    }

    function changeViewPassPort() {
        
    }

    function onUpdateSignature() {
        const callAPIUpdateSignature = async () => {
            const dataUpdate = makeRoomService.signature;
            await branchApi.updateElementBranch(branchID, dataUpdate, "signature", token);
          //  console.log("result,", result)
        }
        callAPIUpdateSignature()
    }

    function closeModal() { dispatch(modalAction.modalReset()); }
    function openModal() { dispatch(modalAction.modalIsOk()); }

    return (
        <UserContext.Provider value={
            {
                listChangeGuest,
                handleChangeListChangeGuest,
                handleDeleteListChangeGuest,
                style,
            }
        }>
            <ModalNotify closeModal={closeModal} />
            {
                <div className="makeRoom">

                    <div className={'makeRoom-back_home d-flex'}
                        onClick={() => history.push(`/reservation`)}>
                        <img src="https://res.cloudinary.com/dsm20cmen/image/upload/v1661232117/database/icon/home.svg"
                            alt={"home"}
                            style={{ width: '25px', height: '27px', verticalAlign: 'middle', color: 'red' }} />
                        <div style={{ marginLeft: '2px' }}>RESERVATION</div>
                    </div>

                    <h1 className="mt-5 makeRoom-title">{!id_history ? "BOOKING INFORMATION" : "BOOKING EDIT HISTORY"}</h1>
                    {
                        id_history && <h3>
                            <>Time make: {makeRoomOnState["timeEdit"]}</>
                            <> -- Device Edit code: {makeRoomOnState["deviceEdit"]}</>
                        </h3>
                    }
                    {
                        makeRoomService.area === "waiting" &&
                        <div>
                             <h3 style={{color:"green"}}>System check : {statusWaiting}</h3>
                        </div>
                    }

                    <div style={{ padding: '0px 24px' }} >

                        <div className="row mb-3">
                            <ListEditLog    
                                selectHistoryIndex={selectHistoryIndex}
                                setSelectHistoryIndex={setSelectHistoryIndex}
                                listHistory = {listHistory}/>
                            <MakeRoomDataGuest
                                style={style}
                                branchID={branchID}
                                lockQuickSelect={idRoom !== "make_waiting"}
                                updateListGuest={updateListGuest}
                                makeRoomOnState={makeRoomOnState}
                                onChangeValueMakeRoom={onChangeValueMakeRoom}
                                handleChangeListChangeGuest={handleChangeListChangeGuest}
                                onChangeGuestDataAfterEdit={onChangeGuestDataAfterEdit}
                                changeViewPassPort={changeViewPassPort}
                            /> 
                            {
                                makeRoomOnState.viewPassPort ? <MakeRoomDataRoom
                                    makeRoomOnState={makeRoomOnState}
                                    onSortListSchedule={onSortListSchedule}
                                    onAddMoreSameListSchedule={onAddMoreSameListSchedule}
                                    onChangeValueMakeRoom={onChangeValueMakeRoom}
                                    onChangeAllDataValueMakeRoom={onChangeAllDataValueMakeRoom}
                                    onChangeValueMakeRoomOther={onChangeValueMakeRoomOther}
                                    onOpenSettingRequest1={onOpenSettingRequest1}
                                    onOpenSettingShowRule2Water={onOpenSettingShowRule2Water}
                                    onConfirmDeleteSchedule={onConfirmDeleteSchedule}
                                    onReturnDefaultSignature={onReturnDefaultSignature}
                                    onUpdateSignature={onUpdateSignature}
                                    viewFullPassPort={viewFullPassPort}
                                    isWaitingList = {idRoom === "make_waiting"}
                                    style={style} /> : <ViewPassPortGuest
                             //       onChangeValueMakeRoom={onChangeValueMakeRoom} 
                                    />
                            }
                            {/* {
                                !makeRoomOnState.viewPassPort && <ViewPassPortGuest
                                    onChangeValueMakeRoom={onChangeValueMakeRoom} />
                            } */}
                        </div>
                        <MakeRoomFooterButton
                            idRoom={idRoom}
                            isHaNoiBranch={isHaNoiBranch}
                            id_history={id_history}
                            option = {{
                                "isHiddenBtn": makeRoomOnState.listSchedule ? (Number(branchID) !== 11) ? makeRoomOnState.listSchedule[0].nights : "" : ""
                               }}
                            idGuest={makeRoomOnState.listGuestSelect ?
                                 (makeRoomOnState.listGuestSelect.length > 0 ? makeRoomOnState.listGuestSelect[0]._id : "") : ""}
                            makeRoomService={makeRoomService}
                            onConfirmMakeRoom={click && onConfirmMakeRoom}
                            onConfirmCheckRoomStatus={onConfirmCheckRoomStatus}
                            onViewHistory={onViewHistory}
                            countEdit = {makeRoomOnState.count + makeRoomService.count}
                            onConfirmEdit={click && onConfirmEdit}
                            onPrintBooking={onPrintBooking}
                            onConfirmRedo={onConfirmRedo}
                            onConfirmMakeHotelInvoice={onConfirmMakeHotelInvoice}
                            onConfirmDeleteSchedule={onConfirmDeleteSchedule}
                            onViewAutoBooking={isHaNoiBranch ? onViewAutoBooking : undefined}
                            onViewMailFormat={makeRoomOnState.listGuestSelect ? (makeRoomOnState.listGuestSelect.length > 0 && onViewMailFormat) : false}
                        />
                    </ div>
                </div>
            }
            
        </UserContext.Provider>
    )
};

export default MakeRoomContainer;
